import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";

export interface PitchFile {
  id: number;
  name: string;
  type: string;
  url: string;
}

interface UseGetPitchFilesProps {
  id: string;
  enabled?: boolean;
}

interface PitchFilesResponse {
  pitchFiles: Array<{
    id: number;
    pitchId: number;
    media: string | null;
    uploadedDate: string;
  }>;
  pitchImageUrls: Array<{
    pitchFileId: number;
    imageUrls: { Media: string };
  }>;
}

export function useGetPitchFiles({
  id,
  enabled = true,
}: UseGetPitchFilesProps) {
  return useQuery<PitchFile[]>({
    enabled,
    queryKey: ["pitch-files", id],
    queryFn: async () => {
      const response = await axiosInstance.get<PitchFilesResponse>(
        getAPIURL(`/Pitch/pitch-files-by-pitch-id/${id}`)
      );
      const data = response.data;

      // merge pitchFiles and pitchImageUrls
      return data.pitchFiles.map((file) => {
        const url =
          data.pitchImageUrls.find((u) => u.pitchFileId === file.id)?.imageUrls
            ?.Media || "";
        const name = url.split("/").pop()?.split("?")[0] || "Unknown";
        const type = name.split(".").pop()?.toUpperCase() || "FILE";
        return { id: file.id, name, type, url };
      });
    },
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      return status !== 400 && failureCount < 3;
    },
  });
}
